import { render, staticRenderFns } from "./aview.vue?vue&type=template&id=72636f4c"
import script from "./aview.vue?vue&type=script&lang=js"
export * from "./aview.vue?vue&type=script&lang=js"
import style0 from "./aview.vue?vue&type=style&index=0&id=72636f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports